import { Field } from './ui.jsx';

/**
 * Simple checkbox multi-select. value is an array of numeric ids.
 */
export default function MultiSelect({ label, options = [], value = [], onChange, empty = 'No options' }) {
  const selected = new Set(value.map(Number));

  function toggle(id) {
    const next = new Set(selected);
    next.has(id) ? next.delete(id) : next.add(id);
    onChange([...next]);
  }

  return (
    <Field label={label}>
      <div className="multiselect">
        {options.length === 0 ? (
          <div className="muted sm" style={{ padding: 6 }}>{empty}</div>
        ) : (
          options.map((o) => (
            <label key={o.id} className={`ms-opt ${selected.has(Number(o.id)) ? 'on' : ''}`}>
              <input
                type="checkbox"
                checked={selected.has(Number(o.id))}
                onChange={() => toggle(Number(o.id))}
              />
              <span>{o.name}</span>
            </label>
          ))
        )}
      </div>
    </Field>
  );
}
